<template>
  <div class="faq-template" theme>
    <div id="faq-content" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      path: 'faq',
      parts: [
        {
          elem: '#faq-content',
          htmlFile: 'faq'
        }
      ]
    }
  }
}
</script>
